import ContactBannerNotification from './ContactBannerNotification';

export default ContactBannerNotification;
